import React, { useEffect } from 'react';

export default function Cookie(fields) {
  // useEffect(() => {
  //   console.log(fields, 'fields11');
  //   const existing = document.getElementById('Cookiebot');
  //   if (existing) return;
  //
  //   const script = document.createElement('script');
  //   script.id = 'Cookiebot';
  //   script.async = true;
  //   script.src = 'https://consent.cookiebot.com/uc.js';
  //   script.setAttribute('data-cbid', '7c6d12a9-024d-4cfb-9513-014e9b1ea10c');
  //   script.setAttribute('data-blockingmode', 'auto');
  //   script.type = 'text/javascript';
  //   document.head.appendChild(script);
  //
  //   return () => {
  //     if (script && script.parentNode) {
  //       script.parentNode.removeChild(script);
  //     }
  //   };
  // }, []);

  return null;
}
